export const SkillGroup = ({ group }) => (
  <div key={group.skillGroupId}>
    <span>
      <i className="fa fa-folder-open-o text-muted margin-right" />
      {group.name}
    </span>
    {group.description && <div className="description small text-muted">{group.description}</div>}
  </div>
);
